import './choice-style.css';
import jacket from "../../assets/img/choice/jacket.png";
import show from "../../assets/img/choice/show.png";
import camera from "../../assets/img/choice/camera.png";
import tlg from "../../assets/img/choice/tlg1.png";
import urgency from  "../../assets/img/choice/urgency1.png";
import dog from "../../assets/img/choice/dog.png";
export const Choice = () => {
    return(
        <section className={'Choice'}>
            <div className={'container choice__container'}>
                <h1 className={'section__title'}>6 причин, почему выбирают ВАУ.. ПРАЗДНИК!!</h1>
                <div className={'choice__content'}>
                    <div className={'content__item'}>
                        <div className={'content__number'}>
                            <img src={jacket} alt={'Современные костюмы'}/>
                        </div>
                        <div className={'content__descr'}>
                            <h2>Современные костюмы и яркий реквизит</h2>
                            <p>Наши герои — в модных образах, шоу — с эффектами, а реквизит — как будто только что с
                                телешоу!</p>
                        </div>
                    </div>
                    <div className={'content__item'}>
                        <div className={'content__number'}>
                            <img src={show} alt={'Уникальные программы и шоу на любой вкус'}/>
                        </div>
                        <div className={'content__descr'}>
                            <h2> Уникальные программы и шоу на любой вкус</h2>
                            <p>Гигантские подушки, блестящие тату, шоу-пузырей, тематические квесты, волшебные
                                мастер-классы — всё продумано до «вау!» и восторга.</p>
                        </div>
                    </div>
                    <div className={'content__item'}>
                        <div className={'content__number'}>
                            <img src={camera} alt={'Фотозоны и декор под стиль вашего праздника'}/>
                        </div>
                        <div className={'content__descr'}>
                            <h2>Фотозоны и декор под стиль вашего праздника</h2>
                            <p>Никаких «всё как у всех» — оформляем индивидуально, с чувством вкуса и трендами.</p>
                        </div>
                    </div>
                    <div className={'content__item'}>
                        <div className={'content__number'}>
                            <img src={tlg} alt={'Всегда на связи и на вашей волне'}/>
                        </div>
                        <div className={'content__descr'}>
                            <h2>Всегда на связи и на вашей волне</h2>
                            <p>VK, Telegram — ответим, подскажем, поддержим, даже если вы пишете ночью.</p>
                        </div>
                    </div>
                    <div className={'content__item'}>
                        <div className={'content__number'}>
                            <img src={urgency} alt={'Быстро, с душой и точно в цель'}/>
                        </div>
                        <div className={'content__descr'}>
                            <h2>Быстро, с душой и точно в цель</h2>
                            <p>Праздник нужен срочно? Мы справимся. Сделаем красиво, без стресса и лишних слов.</p>
                        </div>
                    </div>
                    <div className={'content__item'}>
                        <div className={'content__number'}>
                            <img src={dog} alt={'Официально и удобно'}/>
                        </div>
                        <div className={'content__descr'}>
                            <h2>Официально и удобно</h2>
                            <p>Работаем с физлицами и юрлицами. Договор, счёт, чек — всё чётко, без бюрократии и суеты.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}